var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNonMatchingLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.788,
    height: 33,
    viewBox: "0 0 47.788 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-non-matching-location"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4551",
    "data-name": "Rectangle 4551",
    width: 12.03,
    height: 16.283,
    fill: "#dc083a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24563",
    "data-name": "Group 24563",
    transform: "translate(-1190.212 -757.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23861",
    "data-name": "Group 23861",
    transform: "translate(0 39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23860",
    "data-name": "Group 23860",
    transform: "translate(453.212 186.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1909",
    "data-name": "Rectangle 1909",
    d: "M4,0H47.788a0,0,0,0,1,0,0V29a4,4,0,0,1-4,4H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(737 532)",
    fill: "#dc083a",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24306",
    "data-name": "Group 24306",
    transform: "translate(1208.091 765.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24561",
    "data-name": "Group 24561",
    clipPath: "url(#clip-path-icon-non-matching-location)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49935",
    "data-name": "Path 49935",
    d: "M6.015,0A6.022,6.022,0,0,0,0,6.015,6.94,6.94,0,0,0,.51,8.331a9.7,9.7,0,0,0,.7,1.3L5.33,15.88a.784.784,0,0,0,1.371,0l4.125-6.249a9.66,9.66,0,0,0,.7-1.3,6.938,6.938,0,0,0,.51-2.316A6.022,6.022,0,0,0,6.015,0",
    fill: "#dc083a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49936",
    "data-name": "Path 49936",
    d: "M67.184,64.008a3.184,3.184,0,1,0,3.184,3.184,3.188,3.188,0,0,0-3.184-3.184",
    transform: "translate(-61.169 -61.177)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNonMatchingLocation);
export default __webpack_public_path__ + "static/media/icon-non-matching-location.bf8472d170f3df40c0f2f241e11e1a58.svg";
export { ForwardRef as ReactComponent };